export default "__VITE_ASSET__Y13CJjRp__"